import recipie from '../../../assets/images/product-assets/recipie/recipie.png';
import saveMoney from '../../../assets/images/product-assets/saveMoney/saveMoney.png';
import vegetables from '../../../assets/images/product-assets/vegetables/vegetables.png';


export const subscriptionOrders = [
    {
        "id" : 1,
        "title" : "Save Big On Every Order.",
        "subTitle" : "Join Our Subscription.",
        "description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        "image" : vegetables
    }
]

export const saveMoneyOnOrders = [
    {
        "id" : 1,
        "title" : "Order From Choithrams &",
        "subTitle" : "Save Money Every Time",
        "description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        "image" : saveMoney,

    }
]

export const bestRecipes = [
    {
        "id" : 1,
        "title" : "Find Choithrams Best",
        "subTitle" : "Recipes For Best Food",
        "description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        "image" : recipie
    }
]